import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScPaymentMethodCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 132px;
  height: auto;
  overflow: hidden;
  border-radius: 4px;
  z-index: 1;
  @media (${device.mobile}) {
    width: 100%;
    max-width: none;
    height: 56px;
  }
  .limits-wrapper {
    display: flex;
    justify-content: center;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;

    @media (${device.mobile}) {
      display: none;
    }

    .limits {
      display: flex;
      gap: 3px;
    }
  }
`;
